export default __webpack_public_path__ + "static/media/almostNaked.3dd55ae2.png";